export const RACE_COLORS = {
  eldorians: "#228B22",
  solarians: "#FFD700",
  masons: "#4682B4",
  maritans: "#008B8B",
  zephyrians: "#C0C0C0",
};

export const DEFAULT_RACE_COLOR = "#00f6ff";
export const UNKNOWN_RACE_COLOR = "#4a5568";

export function getRaceColor(race) {
  const key = (race || "").toLowerCase();
  if (key === "unknown") return UNKNOWN_RACE_COLOR;
  return RACE_COLORS[key] || DEFAULT_RACE_COLOR;
}
